export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_GDM_3.bb9186da.jpg";